import { api } from "../utils/apiClient";

export const generateVisibilityReport = (query: string) =>
  api.post("/llm-visibility/generate", { query });

export const getVisibilityReport = (reportId: string) => api.get(`/llm-visibility/${reportId}`);

export const linkVisibilityReport = (reportId: string) =>
  api.post(`/llm-visibility/${reportId}/link`);

export const listVisibilityReports = (signal?: AbortSignal) =>
  api.get("/user/llm-visibility-reports", false, { signal });
